var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column align-center",staticStyle:{"gap":"16px"},style:({
    transform: `translateY(calc(-${_vm.$vuetify.breakpoint.smAndDown ? '70px' : '120px'} * 0.5))`,
  })},[_c('div',{staticClass:"d-flex justify-center",staticStyle:{"width":"250px"}},[_c('v-progress-circular',{attrs:{"striped":"","rounded":"","indeterminate":"","color":"success","width":"10","size":_vm.$vuetify.breakpoint.mdAndUp ? '80' : '50'}})],1),_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }